<template>
  <div class="projects ma-4">
    <v-snackbar v-model="msg" top> {{ text }} <v-btn color="pink" text  @click="msg = false"> Close</v-btn></v-snackbar>
    <v-toolbar elevation="0" class="ml-1 mr-1 pl-1 pr-1">
      <v-toolbar-title>All Tasks</v-toolbar-title>
      <v-spacer></v-spacer>

      <v-text-field
          v-model="search"
          clearable
          flat
          solo-inverted
          hide-details
          prepend-inner-icon="search"
          label="Search"
          class="desktop"
      >
      </v-text-field>
      <v-spacer></v-spacer>
      <v-dialog
          v-model="dialog"
          max-width="100%"
      >
        <template v-slot:activator="{ on }">
          <v-btn color="#2b3990" dark class="mb-2" v-on="on" @click="showAdd()">
            <v-icon left>add</v-icon>

            New Task</v-btn>
        </template>
        <v-card>
          <v-card-title style="background-color: #2b3990;" class="white--text">
            <span class="headline" >{{ titleForm  }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-form ref="form">
                <v-row>
                  <v-col cols="12" sm="12" md="4">
                    <v-text-field
                        v-model="newTitle"
                        label="Task Title"
                        :rules="requiredRules"
                    ></v-text-field>
                  </v-col>
                  <v-col class="d-flex" cols="12" sm="12" md="4">
                    <v-select
                        :items="dstatus"
                        label="Status"
                        v-model="newStatus"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="12" md="4">
                    <v-autocomplete
                        v-model="newAssigned"
                        :items="users"
                        item-text="Name"
                        item-value="_id"
                        label="Assign To"
                        :rules="requiredRules"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <v-textarea
                        label="Description"
                        v-model="newDescription"
                        auto-grow
                        outlined
                        rows="5"
                        row-height="15"
                        :rules="requiredRules"
                    ></v-textarea>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <!-- <v-menu>
                      <template v-slot:activator="{ on }">
                      <v-text-field :value="dueDate" label="Task Due Date" prepend-icon="date_range" v-on="on" :rules="requiredRules"></v-text-field>
                      </template>
                      <v-date-picker v-model="dueDate"></v-date-picker>
                    </v-menu> -->
                    <v-menu
                        ref="menu"
                        v-model="menu"
                        :close-on-content-click="false"
                        :return-value.sync="date"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="dueDate"
                            label="Task Due Date"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            :rules="requiredRules"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                          v-model="dueDate"
                          no-title
                          scrollable
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                            text
                            color="primary"
                            @click="menu = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                            text
                            color="primary"
                            @click="$refs.menu.save(date)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      label="Date Created"
                      readonly
                      v-model="newDateCreated"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="white--text" color="#259647" @click="addTask()" v-if="newLead">Save</v-btn
            >
            <v-btn color="blue darken-1" text @click="updateTask()" v-if="editLead">Update</v-btn
            >
            <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>


    <v-data-table
    :headers="headers"
    :items="tasks"
    class="elevation-1"
    :loading="isLoading"
    loading-text="Loading Tasks..."
    :search="search"
    :options="options"
    @update:options="options = $event"
    :server-items-length="totalItems"
    :items-per-page="options.itemsPerPage"
    :footer-props="{'items-per-page-options': itemsPerPageOptions}"
    :pageCount="pageCount"
    
    :sort-desc="true"
    sort-by="CreatedDate"
    >

      <template v-slot:item.Status=" tasks ">
        <v-chip :color="getColor(tasks.item.Status)" dark outlined label>{{ tasks.item.Status }} </v-chip>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="viewTask(item)">
          mdi-eye
        </v-icon>

        <v-icon small @click="deleteTask(item)">
          mdi-delete
        </v-icon>

      </template>
      <template v-slot:item.approvedAction="{item}">
        <v-btn small color="#13aee4" dark class="mb-2" @click="approvedTask(item._id)">
          Approved
        </v-btn>
      </template>
      <template v-slot:no-data>
        <v-btn color="#2b3990" class="white--text" @click="getTasks()">Reset</v-btn>
      </template>
    </v-data-table>

  </div>
</template>

<script>
import axios from 'axios'
// import Foot from '@/components/footer.vue'
const TaskService = require('../service/task.service');

const url = require("../client_config/config").url;
export default {
  // components: { Foot },
  data: function() {
    return {
      headers: [
        {
          text: "Title",
          align: "start",
          value: "Title",
        },
        { text: "Description", value: "Description" },
        { text: "Status", value: "Status" },
        { text: "Due Date", value: "DueDate" },
        { text: 'Last Updated', value: 'UpdatedDate'},
        { text: "Created Date", value: "CreatedDate",  },
        { text: "Assigned To", value: "StaffName" },
        { text: "Actions", value: "actions", sortable: false },
        { text: "Actions", value: "approvedAction", sortable: false },
      ],
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu: false,
      dialog: false,
      editLead: false,
      newLead: false,
      msg: false,
      text:"",
      search: "",
      dstatus: ['New', 'Pending', 'Overdue', 'Completed'],
      users: [],
      tasks: [],
      userID: localStorage.getItem('userID'),
      titleForm: "New Task",
      newAssigned: "",
      taskID: "",
      newTitle: "",
      newDescription: "",
      dueDate: "",
      newStatus: "New",
      newDateCreated: "",
      updatedBy: "",
      isLoading: true,
      requiredRules: [
        v => !!v || 'This is required',
      ],
      options: {
      page: 1,
      itemsPerPage: 10, // Sync this value with the `itemsPerPage` data property if necessary
        // Other options as needed
      },
      itemsPerPage: 10,
      totalItems: 0,
      itemsPerPageOptions: [10, 20, 50],
      pageCount: 0
      };
  },

  computed: {

  },

  watch: {
    options: {
      handler() {
        this.getTasks();
      },
      deep: true,
    },
    search: {
      handler() {
        this.getTasks();
      }
    }
},

  created() {
    this.getTasks();
    this.getUsers();
      let taskId = this.$route.query.view;

      if (taskId) {
          TaskService.getById(taskId).then((response) => {
              this.viewTask(response.data.task);
          })
      }
  },

  methods: {
    validate () {
      return this.$refs.form.validate()
    },
    getColor(sts){
      if (sts == "New") return 'blue'
      else if (sts=="Pending") return 'orange'
      else if (sts=="Overdue") return 'red'
      else if (sts=="Completed") return 'green'
      else if (sts=="Done") return 'green'
      else return 'teal'
    },

    initialize() {
      this.tasks = [];
    },
    viewTask(item) {
      this.titleForm= "Viewing " + item.Title;
      this.dialog = true;
      this.editLead = true;
      this.newLead = false;
      this.newTitle= item.Title;
      this.newStatus = item.Status;
      this.newDescription= item.Description;
      this.newAssigned= item.Staff;
      this.dueDate= item.DueDate;
      this.newDateCreated = item.CreatedDate;
      this.taskID= item._id;
    },
    showAdd() {
      this.titleForm= "New Task";
      this.newLead = true;
      this.editLead = false;
      this.newTitle= "";
      this.newDescription= "";
      this.newAssigned= "";
      this.dueDate= "";
    },

    deleteTask(item) {
      const id = item._id;
      confirm("Are you sure you want to delete this task?") &&
      this.taskDelete(id);
    },

    taskDelete(id) {
      axios.delete(`${url}/tasks/${id}`)
          .then((response) => {
            this.getTasks();
            if (response.status === 400) {
              response.json().then(function(data) {
                return data.msg;
              });
            }
            this.msg=true;
            this.text="The tasks has been deleted successfully.";
          });
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    approvedTask(id) {
      for(let counterForAllTask = 0; counterForAllTask < this.tasks.length; counterForAllTask++){
        if(this.tasks[counterForAllTask]._id === id){
          if(this.tasks[counterForAllTask].UserId === this.userID && this.tasks[counterForAllTask].Status === 'Completed'){
            var req_body = {
              Status: 'Approved'
            }
            axios.put(`${url}/tasks/${id}`, req_body).then((response) => {
              this.getTasks()
              if (response.status == 400) {
                response.json().then(function(data) {
                  return data.msg
                })
              }
              this.msg = true
              this.text = "The task has been successfully approved"
            });
          }
        }
      }
    },
    updateTask() {
      var req_body = {
        UserId: this.userID,
        Title: this.newTitle,
        Description: this.newDescription,
        DueDate: this.dueDate,
        Status: this.newStatus,
        Staff: this.newAssigned,
        UrlNotification: this.$router.history.current.path
      };

      axios.put(`${url}/tasks/${this.taskID}`, req_body).then((response) => {
        // this.getTasks();
        if (response.status == 400) {
          response.json().then(function(data) {
            alert(data.msg);
          });
        }
        this.newTitle= "";
        this.newDescription= "";
        this.newAssigned= "";
        this.dueDate= "";
        this.msg=true;
        this.text="The task has been updated successfully.";

        let selectedItemIndex = this.tasks.findIndex(item => item._id == this.taskID);
        this.tasks[selectedItemIndex] = Object.assign(this.tasks[selectedItemIndex], response.data)
      }).finally(() => this.close());
      
    },
    getTasks: function() {
  this.isLoading = true;
  // Use the current state of `options` to make the request
  

  let {page, itemsPerPage, sortBy, sortDesc} = this.options;
  const params = {
    page: page,
    limit: itemsPerPage,
    sortField: Array.isArray(sortBy) && sortBy.length > 0 ? sortBy[0] : 'CreatedDate',
    sortDirection: Array.isArray(sortDesc) && sortDesc.length > 0 && sortDesc[0] ? 'desc' : 'asc',
    search: this.search
    // Include any other parameters you might need, such as sorting
  };

  axios.get(`${url}/tasks`, { params })
    .then(response => {
      if (response.data) {

        const {docs, totalPages, totalDocs} = response.data;

        this.tasks = docs;        
        this.pageCount = totalPages;
        this.totalItems = totalDocs;
        
        // No need to manually update page or itemsPerPage since they're driven by v-model
      } else {
        console.error('Unexpected response structure:', response.data);
      }
    })
    .catch(error => {
      console.error('Error fetching tasks:', error);
    })
    .finally(() => {
      this.isLoading = false;
    });
},
    getUsers: function() {
      axios.get(`${url}/users`).then(async res => {
        this.users=res.data.users;
      });
    },

    addTask() {
      if(this.validate()){
        let request_body = {
          UserId: this.userID,
          Title: this.newTitle,
          Description: this.newDescription,
          DueDate: this.dueDate,
          Status: this.newStatus,
          Staff: this.newAssigned,
          UrlNotification: this.$router.history.current.path
        };

        axios.post(`${url}/tasks`, request_body ).then(response => {
          // this.getTasks();
          if (response.status === 400) {
            response.json().then(function(data) {
              this.text=data.msg;
            });
          }
          this.newTitle= "";
          this.newDescription = "";
          this.newAssigned = "";
          this.dueDate = "";
          this.msg=true;
          this.text="The new task has been added successfully.";

          this.tasks.unshift(response.data)
        }).finally(() => this.close());
      }
    },
  },

};
</script>
<style>
@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }

}
</style>
